<div class="options">
  <app-select-market></app-select-market>
  <div class="mission-search">
    <df-select inputId="missionSearch" prefixIcon="heroMagnifyingGlass"
      [placeholder]="'UI.SEARCH.MISSION' | translate"
      [searchPlaceholder]="'UI.SEARCH.MISSION' | translate"
      [options]="missionNameOptions" [searchable]="true" [clearable]="true"
      (selectionChange)="searchMissions($event)" />
  </div>
  @if (statusTranslations) {
    <div class="status">
      <span class="status__label">{{ 'STATUS_LABEL' | translate }}</span>
      @for (status of statusList; track status) {
        <label class="status-chip" [class.disabled]="!isStatusSelected(status)">
          <input type="checkbox" [checked]="isStatusSelected(status)" (change)="toggleStatusSelection(status)"/>
          <span class="dot" [ngStyle]="{ 'background-color': getStatusColor(status) }"></span>
          {{ statusTranslations[status] }}
        </label>
      }
    </div>
  }
</div>

<div id="map" class="map"></div>

<div id="popup" class="ol-popup" [class.ol-popup--visible]="selectedMissions.length > 0">
  <a href="#" id="popup-closer" class="ol-popup-closer"></a>
  <div id="popup-content">
    @for (mission of selectedMissions; track mission) {
      <div class="mission">
        <a [ngStyle]="{'color': getStatusColor(mission.status)}">
          <a style="font-weight: bold;">{{ mission.missionName }}</a><br>
          @for (missionProduct of mission.products; track missionProduct) {
            <a>
              {{ missionProduct.productName }} {{ 'MISSIONS.ORDERED_QUANTITY' | translate }}: {{ missionProduct.productmissionLoadedExpectedMassTotal | number : '1.0-0' }} {{ mission.weightUom }}<br>
            </a>
          }
          <a>{{ 'MISSIONS.FLOWRATE' | translate }}: {{ mission.DMDSExpectedMinFlowrate | number : '1.0-2' }} - {{ mission.DMDSExpectedMaxFlowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</a>
        </a>
        <df-button variant="primary" size="sm" icon="heroChevronRight" iconPosition="end" (onClick)="selectMission(mission)">{{ 'UI.OPEN' | translate }}</df-button>
      </div>
    }
  </div>
</div>
